import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import Link from 'next/link';
import styles from 'sections/Resources/FreightTemplates/PackingList/components/SectionHeader/SectionHeader.module.scss';

const cn = classNames.bind(styles);

const SectionHeader = (): ReactElement => {
  return (
    <section className={cn('header')}>
      <div className={cn('container')}>

        <div className={cn('header__heading-container')}>
          <h1 className={cn('header__heading')}>
            <span>Free Packing List</span>{' '}
            <span>Forms and Templates</span>
          </h1>
          <p className={cn('header__heading-description')}>
            The Commercial Invoice handles the money; the Packing List handles the reality. This
            document is the operational map for your cargo.{' '}
            <Link href='/freight-dictionary/shipment-consolidation'>Cargo consolidators</Link>{' '}
            and warehouse crews swear by the packing list, it's their roadmap to knowing exactly 
            what's in every box, pallet, or container. Stuffing an{' '} 
            <Link href='/freight-dictionary/less-than-container-load'>LCL shipment</Link>{' '} 
            or hauling a full one? That one sheet of paper's the line between everything rolling 
            smooth at delivery and some nightmare customs snag that eats your whole day.
          </p>
        </div>

      </div>
    </section>
  );
};

export default SectionHeader;